import React from "react";
import Image from "mui-image";
import { Link } from "react-router-dom";
import usePermissions from "../permissions/usePermissions";
import { dashboardPermission, navigationLinks } from "./Navigation";
import { TaxPermissionBuilder, TaxPermissionEntity } from "../permissions/TaxGuruPermissionBuilder";

export type NavigationLogoProps = {
    height?: React.CSSProperties["height"] | number | undefined;
};

const NavigationLogo = ({ height }: NavigationLogoProps) => {
    const { hasAtLeastOnePermission } = usePermissions();
    const resolveLink = () => {
        const mayJumpToDashboard = hasAtLeastOnePermission(dashboardPermission);
        const mayJumpToDocuments = hasAtLeastOnePermission(TaxPermissionBuilder.builder().menu(TaxPermissionEntity.TAX_DOCUMENT).build());
        const mayJumpToAccountants = hasAtLeastOnePermission(TaxPermissionBuilder.builder().menu(TaxPermissionEntity.TAX_ACCOUNTANT).build());
        if (mayJumpToDashboard) {
            return "/";
        } else if (mayJumpToDocuments) {
            return navigationLinks.TAX_DOCUMENTS_LINK;
        } else if (mayJumpToAccountants) {
            return navigationLinks.TAX_ACCOUNTANTS_LINK;
        }
    };
    const link = resolveLink();

    if (link) {
        return (
            <Link to={link}>
                <Image duration={500} fit="scale-down" height={height ?? "65px"} src="/logo.svg" />
            </Link>
        );
    }
    return <Image duration={500} fit="scale-down" height={height ?? "65px"} src="/logo.svg" />;
};

export default NavigationLogo;
